export const isCustomAttributeManageable = (attribute, isAdmin = false) => {
  if (isAdmin) return true;
  if (!attribute) return false;

  return (
    attribute.editable_by_agents !== false &&
    attribute.editableByAgents !== false
  );
};

export const isCustomAttributeVisible = (attribute, isAdmin = false) => {
  if (isAdmin) return true;
  if (!attribute) return false;

  return (
    attribute.visible_to_agents !== false && attribute.visibleToAgents !== false
  );
};
